import styled from '@emotion/styled';
// ---- external imports ----

import { withFramerMotionPropsRenamed } from './hoc';
// ---- local imports ----

const FixedTopContainer = withFramerMotionPropsRenamed(styled.div`
	${({ fixedToTopOfBackdropBoxed }) => (fixedToTopOfBackdropBoxed ? '' : 'top: 0;')}
	left: 0;
	width: 100vw;
	height: auto;
	position: absolute;
	${({ fontSize }) => (fontSize ? `font-size: calc( var(--screenScale) * ${fontSize}px)` : '')};
	margin-top: var(--fixedTopContainerMarginTop);

	> * {
		top: 0 !important;
	}
`);


export default FixedTopContainer;
